var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingDiaryViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ae8fea;}.cls-2{fill:#784ace;}.cls-3{fill:#fff;}.cls-4{fill:#5735aa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_training_diary_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.11,
    y: -0.08,
    width: 497.7,
    height: 600,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.93-.08h62.19a0,0,0,0,1,0,0v600a0,0,0,0,1,0,0H79.17a29.05,29.05,0,0,1-29.05-29.05V29.73A29.81,29.81,0,0,1,79.93-.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.04,
    y: 357.85,
    width: 151.74,
    height: 54.83,
    rx: 27.42,
    transform: "translate(-211.3 368.18) rotate(-55.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 236.02,
    y: 343.5,
    width: 139.19,
    height: 54.83,
    rx: 27.42,
    transform: "translate(292.16 -109.5) rotate(37.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 286.99,
    y: 321.33,
    width: 171.01,
    height: 54.83,
    rx: 27.42,
    transform: "matrix(0.57, -0.82, 0.82, 0.57, -126.07, 457.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M432,240.78l-62.49,7.78c-15.3,1.91-20.14,21.71-7.45,30.46l77.43,53.39c12.69,8.75,29.47-2.81,25.82-17.79l-14.94-61.18A16.78,16.78,0,0,0,432,240.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "399.08 161.07 456.39 113.32 513.71 161.07 513.71 3.85 399.08 3.85 399.08 161.07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingDiaryViewEntries);
export default __webpack_public_path__ + "static/media/training_diary_view_entries.38a821b3a2dc549408b25d07488c4873.svg";
export { ForwardRef as ReactComponent };